// Kurla Fitness - Video Autoplay in Marquee
(function() {
  'use strict';
  function initVideoAutoplay() {
    var videos = document.querySelectorAll('.kq-proof-item--video video, .kr-trans-item--video video, .bbb-proof-item--video video');
    if (!videos.length) return;
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) { entry.target.play().catch(function() {}); }
        });
      }, { threshold: 0.1 });
      videos.forEach(function(video) { observer.observe(video); video.play().catch(function() {}); });
    } else {
      videos.forEach(function(video) { video.play().catch(function() {}); });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initVideoAutoplay); }
  else { initVideoAutoplay(); }
  window.addEventListener('pageshow', initVideoAutoplay);
})();